<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="box mt-2">
          <div class="heading">
            <h3>ユーザー</h3>
            <button class="btn btn-primary" @click="handleOpenCreateOffcanvas">登録</button>
          </div>
          <table v-if="page" class="table table-sm table-list table-hover mt-2">
            <thead>
            <tr>
              <th>名前</th>
              <th>メールアドレス</th>
              <th>ステータス</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in page.items" @click="moveToShow(user.id)" class="pointer">
              <td>{{ user.name }}</td>
              <td>{{ user.email }}</td>
              <td class="text-center">{{ user.status.description }}</td>
            </tr>
            </tbody>
          </table>
          <Pagination v-if="page" :page="page" class="mt-3" v-model="filter" @change="changePage"/>
        </div>
      </div>
    </div>
  </div>

  <UserCreateOffcanvas @create="fetch"/>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import {getCurrentAdmin} from '../../../api/admin/AuthApi';
import usePagination from '../../../composables/usePagination';
import useOffcanvas from '../../../composables/useOffcanvas';
import useFlashMessage from '../../../composables/useFlashMessage';
import Pagination from '../../../components/Pagination.vue';
import UserFilter from '../../../filters/admin/UserFilter';
import UserCreateOffcanvas from './UserCreateOffcanvas.vue';

const {openOffcanvas: openCreateOffcanvas} = useOffcanvas('userCreateOffcanvas');
const {errorMessage} = useFlashMessage();

const router = useRouter();

const filter = ref(new UserFilter());
const currentAdmin = ref();

const {page, fetch, changePage} = usePagination(filter.value);

onMounted(async () => {
  currentAdmin.value = await getCurrentAdmin();
});

/**
 * 登録モーダルを開く（MANAGE権限チェック付き）
 */
const handleOpenCreateOffcanvas = () => {
  const hasManagePermission = currentAdmin.value?.permissions?.some(p => p.permissionType === 'MANAGE');

  if (!hasManagePermission) {
    errorMessage('管理権限がないためデータを編集できません');
    return;
  }

  openCreateOffcanvas();
};

/**
 * 詳細画面に遷移
 *
 * @param userId
 */
const moveToShow = userId => {
  router.push({name: 'admin.users.show', params: {id: userId}});
};
</script>
